

















import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
} from '@nuxtjs/composition-api'
import HeaderNextButton from './HeaderNextButton.vue'
import { HeaderNextButtonData, isAccentLabel } from './helpers'

const STORAGE_KEY = 'header-animation-played'
const SHAKE_DURATION = 2500
const SHAKE_DELAY = 200

export default defineComponent({
  name: 'HeaderNextMobileButtons',
  components: { HeaderNextButton },
  props: {
    buttons: {
      type: Array as PropType<HeaderNextButtonData[]>,
      default: () => [],
    },
  },
  setup() {
    const wrapper = ref<HTMLElement | null>(null)
    const container = ref<HTMLElement | null>(null)
    let delayTimer = 0
    let shakeTimer = 0

    const wasPlayed = (): boolean => {
      try {
        return !!localStorage.getItem(STORAGE_KEY)
      } catch {
        return false
      }
    }

    const markPlayed = (): void => {
      try {
        localStorage.setItem(STORAGE_KEY, '1')
      } catch {}
    }

    onMounted(() => {
      const wrapperEl = wrapper.value
      const containerEl = container.value

      if (wasPlayed() || !wrapperEl || !containerEl) return

      const overflow = wrapperEl.scrollWidth - wrapperEl.clientWidth

      if (overflow <= 0) return

      delayTimer = window.setTimeout(() => {
        markPlayed()
        containerEl.style.setProperty(
          '--shake-offset',
          `-${Math.ceil(overflow)}px`
        )
        containerEl.style.setProperty('--shake-duration', `${SHAKE_DURATION}ms`)
        containerEl.classList.add('--shake')

        shakeTimer = window.setTimeout(() => {
          containerEl.classList.remove('--shake')
          containerEl.style.removeProperty('--shake-offset')
        }, SHAKE_DURATION)
      }, SHAKE_DELAY)
    })

    onBeforeUnmount(() => {
      clearTimeout(delayTimer)
      clearTimeout(shakeTimer)
    })

    return { wrapper, container, isAccent: isAccentLabel }
  },
})
